@keyframes reveal {
  0% {
    opacity: 0;
    transform: translateY(1rem)
  }
}

@keyframes hide {
  100% {
    opacity: 0;
    transform: translateY(-1rem);
    visibility: hidden;
  }
}

:host {
  display: block;
  position: absolute;
  font-family: "Work Sans", sans-serif;
  z-index: var(--z-index-notification-manager, 100);
  pointer-events: none;
}

:host([name='global']) {
  position: fixed;
  width: 300px;
}

.amalitech-alert {
  pointer-events: none;
  display: flex;
  flex-direction: column;
  margin: var(--spacing-04, 0.75rem);

  .alert {
    animation: reveal 0.5s ease-in;
    pointer-events: auto;
  }

  .alert.hidden {
    display: none;
  }

}

:host([position="bottom-right"]) {
  bottom: 0;
  right: 0;

  .amalitech-alert {
    align-items: flex-end;
  }
}

:host([position="bottom-left"]) {
  bottom: 0;
  left: 0;

  .amalitech-alert {
    align-items: flex-start;
  }
}

:host([position="top-left"]) {
  top: 0;
  left: 0;

  .amalitech-alert {
    align-items: flex-start;
  }
}

:host([position="top-right"]) {
  top: 0;
  right: 0;

  .amalitech-alert {
    align-items: flex-end;
  }
}

